import React from 'react'

function ForgotPassword() {
  return (
    <>Forgot Password</>
  )
}

export default ForgotPassword